(function () {
  function initCarousel(root) {
    var track = root.querySelector('.sbc__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sbc__slide'));
    if (!track || slides.length === 0) return;

    var prevBtn = root.querySelector('.sbc__arrow--prev');
    var nextBtn = root.querySelector('.sbc__arrow--next');
    var dotsWrap = root.querySelector('.sbc__dots');
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 4000;
    var timer = null;
    var isPointerDown = false;

    function getVisibleCount() {
      var slideWidth = slides[0].getBoundingClientRect().width;
      var trackWidth = track.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return Math.max(1, Math.round((trackWidth + gap) / (slideWidth + gap)));
    }

    function getPageCount() {
      var visible = getVisibleCount();
      return Math.max(1, Math.ceil(slides.length / visible));
    }

    function getCurrentPage() {
      var visible = getVisibleCount();
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var pageWidth = (slideWidth + gap) * visible;
      return Math.round(track.scrollLeft / pageWidth);
    }

    function scrollToPage(pageIndex) {
      var visible = getVisibleCount();
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var pageWidth = (slideWidth + gap) * visible;
      var pageCount = getPageCount();

      if (pageIndex < 0) pageIndex = pageCount - 1;
      if (pageIndex >= pageCount) pageIndex = 0;

      track.scrollTo({ left: pageWidth * pageIndex, behavior: 'smooth' });
      updateDots(pageIndex);
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pageCount = getPageCount();
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sbc__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            scrollToPage(idx);
            restartAutoplay();
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots(activeIndex) {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.sbc__dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }

    function next() {
      scrollToPage(getCurrentPage() + 1);
    }

    function prev() {
      scrollToPage(getCurrentPage() - 1);
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= getVisibleCount()) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        restartAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        restartAutoplay();
      });
    }

    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', startAutoplay);
    track.addEventListener(
      'touchstart',
      function () {
        stopAutoplay();
      },
      { passive: true }
    );
    track.addEventListener('touchend', function () {
      restartAutoplay();
    });

    var scrollTimeout;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          updateDots(getCurrentPage());
        }, 100);
      },
      { passive: true }
    );

    buildDots();
    startAutoplay();

    window.addEventListener('resize', function () {
      buildDots();
    });
  }

  function initAll() {
    document.querySelectorAll('.sbc').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.sbc');
    if (section) initCarousel(section);
  });
})();
